import React, { Component } from 'react';
import { getHistoryList } from '../../modules/Api';
import ReactTable from 'react-table'
import DatePicker from 'mopon-react-datepicker2';


class History extends Component {
    constructor() {
        super();

        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    getUri() {
        const type = this.props.match.params.type;
        const id   = this.props.match.params.id;

        let uri;
        uri = type ? `${type}`      : '';
        uri = id   ? `${uri}/${id}` : uri;

        return uri;
    }

    fetchData = (query = '') => {
        getHistoryList(this.getUri(), query, (res) => {this.setState({
            items: res.data,
            last_page: res.last_page,
            count: res.total,
            pageSize: res.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');


        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;

        this.fetchData(query);
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                filterable: true,
            },
            {
                Header: 'نام کاربر',
                accessor: 'first_name',
                filterable: true,
            },
            {
                Header: 'نام خانوداگی',
                accessor: 'last_name',
                filterable: true,
            },
            {
                Header: 'نوع تغییر',
                accessor: 'revisionable_type',
                filterable: true,
                Cell: (row) => (
                    <span title={row.original.revisionable_type}>
                        <div><small>{row.original.revisionable_type}</small></div>
                    </span>
                )
            },
            {
                Header: 'آیدی تغییر',
                accessor: 'revisionable_id',
                filterable: true,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: true,
            },
            {
                Header: 'فیلد',
                accessor: 'key',
                sortable: true,
                filterable: true,
            },
            {
                Header: 'مقدار قدیم',
                accessor: 'old_value',
                sortable: true,
                filterable: true,
                Cell: row => (<span title={row.original.old_value}>{row.original.old_value}</span>)
            },
            {
                Header: 'مقدار جدید',
                accessor: 'new_value',
                sortable: true,
                filterable: true,
                Cell: row => (<span title={row.original.new_value}>{row.original.new_value}</span>)
            },
            {
                Header: 'تاریخ',
                accessor: 'created_at',
                sortable: true,
                filterable: true,
                Cell: (row) => (<div dir="ltr" title={row.original.created_at}> {row.original.created_at} </div>),
                Filter:  ({ filter, onChange }) =>
                    <div style={{direction: 'ltr'}} >
                        <DatePicker onChange={value => onChange(value.format('YYYY-MM-DD HH:mm:ss'))} timePicker={false} inputFormat="YYYY-MM-DD"/>
                    </div>
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default History;


// WEBPACK FOOTER //
// ./src/containers/history/index.js